import { gql } from 'apollo-angular';

export const FIND_ALL_PAYMENTS_PAGINATION = gql`
  query findAllPaymentsWithPagination($input: PaymentPaginationInput) {
    findAllPaymentsWithPagination(input: $input) {
      payments {
        id
        paymentType
        amount
        currencyId
        # currencyData
        paymentMethod
        isCheque
        chequeNo
        chequeDate
        referenceNo
        paymentDate
        paymentStatus
        notes
        paymentCode
        customerId
        customerData {
          firstName
          lastName
        }
        vendorId
        vendorData {
          vendorName
        }
        # vendorData
        # employeeId
        bankAccountId
        # bankData
        creditCardId
        # creditCardData
        branchId
        branchData {
          address
          branchName
        }
        journalId
        # journalData
        approvedBy
        status
        paymentInfo {
          id
          amount
          refType
          invoice {
            id
            invoiceNo
            invoiceDate
            totalAmount
          }
          bill {
            id
            billNo
            billDate
            totalAmount
          }
        }
        createdAt
        updatedAt
        deletedAt
      }
      total
      skip
      limit
    }
  }
`;
export const BANK_ACCOUNTS = gql`
  query bankAccounts($search: String, $branchId: Int) {
    bankAccounts(search: $search, branchId: $branchId) {
      id
      bankName
      branchId
      branchData {
        id
        branchName
        branchLogo
        address
        branchCode
        createdAt
        updatedAt
        deletedAt
        # status
        employeeCount
        managerId
        # managerData
      }
      accountNumber
      # IFSCCode
      accountType
      currency
      openingBalance
      isActive
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const CREDIT_CARDS = gql`
  query creditCards($search: String, $branchId: Int) {
    creditCards(search: $search, branchId: $branchId) {
      id
      cardName
      cardNumberMasked
      issuer
      branchId
      branchData {
        id
        branchName
        branchCode
      }
      creditLimit
      currentBalance
      currency
      expiryDate
      isActive
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const GET_BILLS = gql`
  query fetchOpenOrPartiallyPaidBills($vendorId: Int!) {
    fetchOpenOrPartiallyPaidBills(vendorId: $vendorId) {
      id
      billNo
      vendorId
      vendorData {
        id
        vendorName
      }
      accountId
      accountData {
        id
        accountType
        accountName
        accountCode
      }
      branchId
      billDate
      dueDate
      subTotal
      tax
      totalAmount
      paymentStatus
      balance
      journalId
      journalData {
        id
        journalNo
      }
      paidDate
      isApproved
      approvedOrRejectedBy
      billUrl
      billStatus
      status
      billItems {
        id
        billId
        itemName
      }
    }
  }
`;
export const GET_INVOICES = gql`
  query fetchOpenOrPartiallyPaidInvoices($customerId: Int!) {
    fetchOpenOrPartiallyPaidInvoices(customerId: $customerId) {
      id
      invoiceNo
      subTotal
      discount
      tax
      totalAmount
      balance
      invoiceStatus
      paymentStatus
      orderId
      orderData {
        id
        customerId
        orderCode
        orderDate
        totalAmount
      }
      branchId
      customerId
      customerData {
        id
        firstName
        lastName
      }
      journalId
      journalData {
        id
        journalNo
        refType
        refId
        reference
        notes
        createdBy
        postedAt
        status
        date
        totalAmount
        isManual
      }
      invoiceDate
      dueDate
      paidDate
      IsApproved
      approvedOrRejectedBy
      status
      invoiceUrl
      invoiceItems {
        id
        invoiceId
        itemName
        totalAmount
      }
      createdAt
      updatedAt
      deletedAt
      paymentInfos {
        id
        paymentId
        refType
        refId
        amount
      }
    }
  }
`;
export const GET_PAYMENT_BY_ID = gql`
  query payment($id: Int!) {
    payment(id: $id) {
      id
    paymentType
    amount
    currencyId
    # currencyData {
    #   id
    #   currencyCode
    #   currencyName
    #   currencySymbol
    #   exchangeRate
    #   status
    #   isPrimary
    #   createdAt
    #   updatedAt
    #   deletedAt
    # }
    paymentMethod
    isCheque
    chequeNo
    chequeDate
    referenceNo
    paymentDate
    paymentStatus
    notes
    paymentCode
    customerId
    customerData {
      # id
      firstName
      lastName
      # email
      # phoneNumber
      # address
      # city
      # state
      # country
      # zipCode
      # gender
      # dateOfBirth
      # preferences
      # branchId
      # # branchData
      # status
      # createdAt
      # updatedAt
      # deletedAt
    }
    vendorId
    vendorData {
      id
      # branchId
      # branchData
      vendorName
      # contactPerson
      # email
      # phone
      address
      trn
      # currency
      # openingBalance
      # status
      # createdAt
      # updatedAt
      # deletedAt
    }
    # employeeId
    bankAccountId
    bankData {
      id
      bankName
      # branchId
      # branchData
      # accountNumber
      # IFSCCode
      # accountType
      # currency
      # openingBalance
      # isActive
      # createdAt
      # updatedAt
      # deletedAt
    }
    creditCardId
    creditCardData {
      id
      cardName
      # cardNumberMasked
      # issuer
      # branchId
      # branchData
      # creditLimit
      # currentBalance
      # currency
      # expiryDate
      # isActive
      # createdAt
      # updatedAt
      # deletedAt
    }
    branchId
    branchData {
    #   id
      branchName
      # branchLogo
      address
      branchCode
    #   createdAt
    #   updatedAt
    #   deletedAt
    #   status
    #   employeeCount
    #   managerId
    #   # managerData
    }
    journalId
    journalData {
      id
      journalNo
      refType
      refId
      # reference
      # notes
      # createdBy
      postedAt
      status
      date
      totalAmount
      # isManual
      journalEntries{
        accountData{
          accountName
          # accountType
          accountCode
        }
        debit
        credit
      }
      # createdAt
      # updatedAt
      # deletedAt
    }
    approvedBy
    approver {
      id
      firstName
      lastName
    }
    status
    paymentUrl
    paymentInfo {
      id
      paymentId
      # paymentData
      refType
      refId
      amount
      invoice{
        invoiceNo
        invoiceDate
        totalAmount
      }
      bill{
        billNo
        billDate
        totalAmount
      }
      # createdAt
      # updatedAt
      # deletedAt
    }
    createdAt
    updatedAt
    }
  }
`;
